// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editprojectfields {
    margin-top: 30px;
    display: grid;
    grid-template-columns: 40% ;
    grid-column-gap: 70px;
    grid-row-gap: 40px;
    padding: 10px;
    justify-content: center;
    margin-bottom: 30px;
  } 
  .editformLayout {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  .editformDetails {
    background-color: white !important;
    /* padding: 1% 0; */
    width: 95%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    /* width: 40%; */
    border-radius: 5px;
  }
  .editprojectbutton {
    background-color: #8b5ccc;
    border: none;
    color: white;
    padding: 5px 27px;
    text-align: center;
    font-size: 20px;
    margin-bottom: 60px;
    border-radius: 5px;
  }

  .editprojectbutton:hover {
    background-color: rgba(54, 3, 125, 0.919);
    color: white;
  }

  .back {
    padding: 5px 27px;
    text-align: center;
    font-size: 20px;
  }
  /* .projectbutton:hover {
    background-color: rgba(82, 82, 90, 0.919);
    color: white;
  } */
  
  .editheading {
    padding: 10px 10px;
    color: #030a1d;
    background-color: #e1e0e0;
  }
  .projectheading {
    margin-top: 30px;
    margin-bottom: 30px;
    color: rgb(40, 121, 241);
  }
  .editheading > h4 {
    margin-left: 30px;
  }
  
  /* .my-hr {
    border: none;
    height: 1px;
    background-color: #ccc;
  } */
  `, "",{"version":3,"sources":["webpack://./src/components/editcomponent/editproject/editproject.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,2BAA2B;IAC3B,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,kCAAkC;IAClC,mBAAmB;IACnB,UAAU;IACV,0CAA0C;IAC1C,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,yCAAyC;IACzC,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;EACA;;;KAGG;;EAEH;IACE,kBAAkB;IAClB,cAAc;IACd,yBAAyB;EAC3B;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;;EAEA;;;;KAIG","sourcesContent":[".editprojectfields {\n    margin-top: 30px;\n    display: grid;\n    grid-template-columns: 40% ;\n    grid-column-gap: 70px;\n    grid-row-gap: 40px;\n    padding: 10px;\n    justify-content: center;\n    margin-bottom: 30px;\n  } \n  .editformLayout {\n    display: flex;\n    justify-content: center;\n    margin-top: 30px;\n  }\n  .editformDetails {\n    background-color: white !important;\n    /* padding: 1% 0; */\n    width: 95%;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n    transition: 0.3s;\n    /* width: 40%; */\n    border-radius: 5px;\n  }\n  .editprojectbutton {\n    background-color: #8b5ccc;\n    border: none;\n    color: white;\n    padding: 5px 27px;\n    text-align: center;\n    font-size: 20px;\n    margin-bottom: 60px;\n    border-radius: 5px;\n  }\n\n  .editprojectbutton:hover {\n    background-color: rgba(54, 3, 125, 0.919);\n    color: white;\n  }\n\n  .back {\n    padding: 5px 27px;\n    text-align: center;\n    font-size: 20px;\n  }\n  /* .projectbutton:hover {\n    background-color: rgba(82, 82, 90, 0.919);\n    color: white;\n  } */\n  \n  .editheading {\n    padding: 10px 10px;\n    color: #030a1d;\n    background-color: #e1e0e0;\n  }\n  .projectheading {\n    margin-top: 30px;\n    margin-bottom: 30px;\n    color: rgb(40, 121, 241);\n  }\n  .editheading > h4 {\n    margin-left: 30px;\n  }\n  \n  /* .my-hr {\n    border: none;\n    height: 1px;\n    background-color: #ccc;\n  } */\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
